import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const x = defineConnector({
  identifier: "x",
  name: "X",
  tagLine: "X platform APIs",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.x\\.com/.*",
  auth: (app) => bearerAuth(app.secret.bearerToken),
  steps: [
    {
      title: "Create an OAuth 2.0 user access token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://docs.x.com/fundamentals/authentication/oauth-2-0/overview](https://docs.x.com/fundamentals/authentication/oauth-2-0/overview) and [https://docs.x.com/x-api/users/get-my-user](https://docs.x.com/x-api/users/get-my-user) to create an OAuth 2.0 user access token for the X API. The `/2/users/me` endpoint requires user context and the `users.read` scope.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "OAuth 2.0 user access token",
          required: true,
          target: {
            kind: "secrets",
            field: "bearerToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.x.com/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://api.x.com/2/users/me")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
